function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.91 5.47l-3.536-3.536L13.789.52c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.83L15.91 5.468zm-1.414 1.414l-9.9 9.9L0 17.844l1.06-4.596 9.9-9.9 3.536 3.536z",
  fill: "#000"
}));